import { type MouseEvent, type ReactNode } from "react";
import { DialogActions, DialogContent, DialogHeader, DialogTitle } from "~/common/mui";
import ResponsiveDialogDrawer from "./ResponsiveDialogDrawer";

export interface AtcDialogShellProps {
  children?: ReactNode;
  footer?: ReactNode;

  onClose: (e?: MouseEvent) => void;

  title?: string;
}

export const AtcDialogShell = (props: AtcDialogShellProps) => {
  const { children, footer, onClose, title } = props;

  return (
    <ResponsiveDialogDrawer open={true} onClose={onClose} maxWidth="desktop-l">
      <DialogHeader onClose={onClose}>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      <DialogContent>{children}</DialogContent>
      <DialogActions>{footer}</DialogActions>
    </ResponsiveDialogDrawer>
  );
};
